"use strict";
/* eslint-disable no-return-assign */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-cond-assign */
/**
 *  Função que retorna data formatada em pt-BR
 *  @param {string} value Recebe um valor ISO
 *  @example formatDate('2010-10-01T00:00:00Z') => '01/10/2010'
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInRange = exports.compareDates = exports.convertDate = exports.addDays = exports.formatDate = void 0;
var formatDate = function (value) {
    return new Date(value)
        .toISOString()
        .split('T')[0]
        .split('-')
        .slice(0, 3)
        .reverse()
        .join('/');
};
exports.formatDate = formatDate;
/**
 *  Função para adicionar x dias a data e retorná-lano formato Date
 *  @param {string} value Recebe um valor ISO
 *  @example formatDate('2010-10-01T00:00:00Z',5) => '2010-10-06T00:00:00Z'
 */
function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}
exports.addDays = addDays;
/**
 * Converts the date in d to a date-object. The input can be:
 *
 *   a date object: returned without modification
 *   an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
 *   a number     : Interpreted as number of milliseconds
 *                   since 1 Jan 1970 (a timestamp)
 *   a string     : Any format supported by the javascript engine, like
 *                   "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
 *   an object     : Interpreted as an object with year, month and date
 *                   attributes.  **NOTE** month is 0-11.
 */
function convertDate(d) {
    return d.constructor === Date
        ? d
        : d.constructor === Array
            ? new Date(d[0], d[1], d[2])
            : d.constructor === Number
                ? // @ts-ignore
                    new Date(d)
                : d.constructor === String
                    ? // @ts-ignore
                        new Date(d)
                    : typeof d === 'object'
                        ? new Date(d.year, d.month, d.date)
                        : NaN;
}
exports.convertDate = convertDate;
/**
Compare two dates (could be of any type supported by the convert
function above) and returns:

  _-1_ : if a < b

    _0_ : if a = b

    _1_ : if a > b

 NaN : if a or b is an illegal date

 NOTE: The code inside isFinite does an assignment (=).
 */
function compareDates(a, b) {
    // eslint-disable-next-line no-return-assign
    return Number.isFinite((a = convertDate(a).valueOf())) &&
        Number.isFinite((b = convertDate(b).valueOf()))
        ? // @ts-ignore
            (a > b) - (a < b)
        : NaN;
}
exports.compareDates = compareDates;
/**
Checks if date in d is between dates in start and end.
 Returns a boolean or NaN:
  
   true  : if d is between start and end (inclusive)
  
      false : if d is before start or after end
  
      NaN   : if one or more of the dates is illegal.
  
      __NOTE__ : The code inside isFinite does an assignment (=).
 */
function isInRange(d, start, end) {
    return Number.isFinite((d = convertDate(d).valueOf())) &&
        Number.isFinite((start = convertDate(start).valueOf())) &&
        Number.isFinite((end = convertDate(end).valueOf()))
        ? start <= d && d <= end
        : NaN;
}
exports.isInRange = isInRange;
exports.default = {
    /**
     * Converts the date in d to a date-object. The input can be:
     *
     *   a date object: returned without modification
     *   an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
     *   a number     : Interpreted as number of milliseconds
     *                   since 1 Jan 1970 (a timestamp)
     *   a string     : Any format supported by the javascript engine, like
     *                   "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
     *   an object     : Interpreted as an object with year, month and date
     *                   attributes.  **NOTE** month is 0-11.
     */
    convert: convertDate,
    /**
  Compare two dates (could be of any type supported by the convert
  function above) and returns:
  
    _-1_ : if a < b
  
      _0_ : if a = b
  
      _1_ : if a > b
  
   NaN : if a or b is an illegal date
  
   NOTE: The code inside isFinite does an assignment (=).
   */
    compare: compareDates,
    /**
  Checks if date in d is between dates in start and end.
   Returns a boolean or NaN:
    
     true  : if d is between start and end (inclusive)
    
        false : if d is before start or after end
    
        NaN   : if one or more of the dates is illegal.
    
        __NOTE__ : The code inside isFinite does an assignment (=).
   */
    inRange: isInRange,
    /**
     *  Função para adicionar x dias a data e retorná-lano formato Date
     *  @param {string} value Recebe um valor ISO
     *  @example formatDate('2010-10-01T00:00:00Z',5) => '2010-10-06T00:00:00Z'
     */
    add: addDays,
    /**
     *  Função que retorna data formatada em pt-BR
     *  @param {string} value Recebe um valor ISO
     *  @example formatDate('2010-10-01T00:00:00Z') => '01/10/2010'
     */
    format: exports.formatDate,
};
//# sourceMappingURL=formatDate.js.map